export const roleChecker = (value: string):boolean => {
  const role = JSON.parse(localStorage.getItem('magner-petshop') || '');
  return role?.role === value;
};
